export default __webpack_public_path__ + "static/media/Ficha Técnica - Purê de Manga Asséptica Concentrada. BRIX 16-18 VARIEDADE PALMER.0f2490f4.pdf";